import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { Check } from 'src/app/shared/models/check';
import { Card, TranCode, Transaction } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { CCProcessors } from 'src/app/shared/models/enums/CCProcessors.enum';

@Component({
	selector: 'app-batch-record-detail',
	templateUrl: './batch-record-detail.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class BatchRecordDetailComponent implements OnInit {
	@Input() transactions: Transaction[];

	checkSelected: Check;

	tranCodeList: GenericLabelValue[] = [];
	cardTypeList: GenericLabelValue[] = [];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		Object.values(TranCode).forEach((key) => {
			if (isNaN(+key)) {
				this.tranCodeList.push({ label: TranCode[key], value: key });
			}
		});

		Object.keys(Card).forEach((key) => {
			const cardTypeDisplayObject = this.app.references.creditCardTypeToDisplayObject(undefined, Card[key], CCProcessors.FOCUSPAYDATACAP);
			this.cardTypeList.push({ label: cardTypeDisplayObject.name, value: key, meta: cardTypeDisplayObject.faIcon });
		});

		console.log(this.cardTypeList);
	}

	async selectTransaction(invoiceNumber: string, businessDate: string) {
		this.app.loading(true);
		const query = `checkNumber=${+invoiceNumber}&businessDate=${this.app.moment(businessDate, 'MMDDYYYY').format('YYYY-MM-DD')}`;
		try {
			const resp = await this.focuslink.checksGetByParams(this.venueService.subscriptionVenue.value.key, query);
			this.checkSelected = new Check(resp[0]);
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Corresponding POS transaction not found` });
		}
		this.app.loading(false);
	}

	exportExcel() {
		import('xlsx').then((xlsx) => {
			const worksheet = xlsx.utils.json_to_sheet(this.transactions.map((i) => i.Summary));
			const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
			const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
			this.saveAsExcelFile(excelBuffer, `Batch ${this.transactions[0].Summary.Batch} - ${this.transactions[0].Summary.businessDate}`);
		});
	}

	saveAsExcelFile(buffer: any, fileName: string): void {
		let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		let EXCEL_EXTENSION = '.xlsx';
		const data: Blob = new Blob([buffer], {
			type: EXCEL_TYPE,
		});
		FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
	}
}
